<template>
    <v-group :config="groupConfig">
        <v-line :config="lineConfig"></v-line>
    </v-group>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';

    export default {
        name: "LineRib",

        props: [
            'x',
            'y',
            'ribsSideCoefficient',
            'lineColor',
        ],

        computed: {
            ...mapState('line', [
                'ribSideLegLength',
            ]),

            ...mapGetters('editor', [
                'footToPx',
            ]),

            ...mapGetters('line', [
                'ribLegFoolLength',
            ]),

            groupConfig() {
                return {
                    x: this.x,
                    y: this.y,
                }
            },

            lineConfig() {
                // height and width of the side part
                const sideLegPosDiff = this.ribSideLegLength * this.footToPx / Math.sqrt(2);

                // To simplify the drawing, the part that becomes the rib
                // remains the same length - 1 foot.
                // To achieve this, calc the mainLeg length instead of use 0.5 foot
                const mainLegLength = this.ribLegFoolLength * this.footToPx - (sideLegPosDiff * 2);

                // ribs always should be on the paint side
                let y = sideLegPosDiff * this.ribsSideCoefficient;

                let points = [
                    0, 0,
                    sideLegPosDiff, y,
                    sideLegPosDiff + mainLegLength, y,
                    sideLegPosDiff * 2 + mainLegLength, 0,
                ];

                return {
                    name: 'LineRib',
                    points,
                    stroke: this.lineColor,
                    strokeWidth: 3,
                    hitStrokeWidth: 3,
                    lineCap: 'round',
                    lineJoin: 'round',
                }
            },

        },

    }
</script>

<style scoped>

</style>